export const getSavedKey = (userDataKey: string) =>
  /\/saved/.test(userDataKey)
    ? userDataKey
    : userDataKey.replace(/search_history/i, 'search_history/saved')

export const getUnsavedKey = (userDataKey: string) => userDataKey.replace(/\/saved/, '')
